import { StorageKey } from '../../../enum/StorageKey';

import { initAxiosAGMS } from '../../../service/axios-agms';
import { loadHealthMonitorTokens } from '../../auth';

import { getItemFromSessionStorage } from '../../session-storage';

export const rootLoader = () => {
  const accessToken = getItemFromSessionStorage(StorageKey.ACCESS_TOKEN)?.trim();

  if (accessToken) {
    initAxiosAGMS(accessToken);

    // Use this solution until AGMS and Health Monitor begin to share same JWT
    loadHealthMonitorTokens();

    return true;
  }

  return false;
};
